'use strict';

const waitsLeft = [50, 150, 350, 750, 950];

function waitOnEvent({
  doneCheck,
  callback,
  fallback,
  totalWaits = waitsLeft,
}) {
  const waiter = index => {
    const done = doneCheck();

    if (done) {
      return callback(done);
    }

    const wait = totalWaits[index];
    if (wait) {
      return setTimeout(() => waiter(index + 1), wait);
    }

    return fallback();
  };

  waiter(0);
}

module.exports = {
  waitOnEvent,
};
